import React from 'react';
import sharedAction from 'shared/routes/journal/videos';
import { setTargetingArguments } from 'shared/actions/globals';
import DESCRIPTION from 'shared/constants/seoDescriptions';
import TITLE from 'shared/constants/seoTitles';
import { getRubricsNavigation } from 'shared/helpers/journal';
import Layout from 'desktop/components/Layout';
import { getTitleOrEmpty } from '../../../../shared/helpers/common';
import Videos from './Videos';

async function action(params) {
  const { store, translate } = params;
  const pageParams = await sharedAction(params);

  if (!pageParams) {
    return null;
  }

  if (!pageParams.count) {
    return {
      status: 301,
      redirect: '/',
    };
  }

  const {
    makes,
    videoContent,
    currentPage,
    pageCount,
    url,
    query,
    targetingArguments,
    rubrics,
    currentRubric,
  } = pageParams;

  const title = TITLE.JOURNAL.NEWS(translate, getTitleOrEmpty(currentRubric));
  const description = DESCRIPTION.JOURNAL.NEWS(translate, getTitleOrEmpty(currentRubric));
  const isLastPage = currentPage === pageCount;

  store.dispatch(setTargetingArguments(targetingArguments));

  return {
    chunks: ['journal'],
    title,
    page: currentPage,
    isLastPage,
    description,
    component: (
      <Layout
        navLinks={getRubricsNavigation(rubrics)}
        currentRoute={url}
        including={false}
        hideLocations
      >
        <Videos
          videoContent={videoContent}
          makes={makes}
          currentPage={currentPage}
          pageCount={pageCount}
          url={url}
          query={query}
          currentRubric={currentRubric}
        />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/journal/videos/index.js